
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1360","height":"623","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1360 0H0v622.21h1360V0z","fill":"#4D4D4D"}}),_c('path',{attrs:{"d":"M36.14 20.26H23.16c-6.633 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.377 12.01 12.01 12.01h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.377-12.01-12.01-12.01zm-.15 558.95H23.01c-6.633 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.377 12.01 12.01 12.01h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.377-12.01-12.01-12.01zM1337.31 19.95h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01zm-.15 558.95h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01zM1268 0v.45c0 8.13 2.28 14.72 5.1 14.72s5.1-6.59 5.1-14.72V0H1268zm0 622.21v-.45c0-8.13 2.28-14.73 5.1-14.73s5.1 6.6 5.1 14.73v.45H1268zM77.55 0v.45c0 8.13 2.29 14.72 5.11 14.72 2.82 0 5.1-6.59 5.1-14.72V0H77.55zm0 622.21v-.45c0-8.13 2.29-14.73 5.11-14.73 2.82 0 5.1 6.6 5.1 14.73v.45H77.55z","fill":"#fff"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h1360v622.21H0z"}})])])])
          )
        }
      }
    